export default class DadosCertificadoModel {
    constructor(public co_certificado: String,
                public de_nome_comum: String,
                public de_razao_social: String,
                public no_autoridade_certificadora: String,
                public no_responsavel: String,
                public nu_certificado: number,
                public nu_cpf: number,
                public nu_entidade_certificada: number,
                public nu_inscricao: number,
                public nu_perfil: number,
                public nu_pis: number,
                public de_perfil: String) {}
}
